export const groupByAlphabet =(prop)=>{
  let data = prop.reduce((r, e) => {
    let group = e.professionalName[0];
    if (!r[group]) r[group] = { group, children: [ e ] };
    else r[group].children.push(e);
    return r;
  }, {});
    
  return Object.values(data);   
};